var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgKey = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.a{fill:none;}\n\t.b{fill:#C1C1C1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2.1-2.1h25v25h-25V-2.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.8,18.4c-3.5,0-6.4-2.9-6.4-6.4s2.9-6.4,6.4-6.4c2.6,0,4.7,1.4,5.8,3.6l10.1-0.1v4.9h-1.9v3.8h-5.1v-3.4 l-3,0.1C12.6,16.9,10.3,18.4,7.8,18.4z M7.8,7.5c-2.5,0-4.6,2-4.6,4.6s2,4.6,4.6,4.6c1.9,0,3.6-1.3,4.3-3.2l0.2-0.6l6.1-0.2v3.5 H20v-3.8h1.9V11l-9.5,0.1l-0.2-0.6C11.5,8.7,9.8,7.5,7.8,7.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.8,14.7c-1.5,0-2.6-1.2-2.6-2.6c0-1.5,1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6C10.5,13.5,9.3,14.7,7.8,14.7z M7.8,11.2C7.4,11.2,7,11.6,7,12s0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8S8.3,11.2,7.8,11.2z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/key.57ddccb0.svg";
export { ForwardRef as ReactComponent };